export enum BSVariantStatusEnum {
  IN_PROGRESS = "IN_PROGRESS",
  DELETED = "DELETED",
}

export function bsVariantStatusToLabel(status: BSVariantStatusEnum | undefined): string {
  switch (status) {
    case BSVariantStatusEnum.IN_PROGRESS:
      return "En cours"
    case BSVariantStatusEnum.DELETED:
      return "Supprimé"
    default:
      return ""
  }
}
